import React, { useState, useLayoutEffect } from 'react';

const Sizer = (Comp) => {
	return (props = {}) => {
		const [sizeSet, setSizeSet] = useState(false),
			[winWidth, setWinWidth] = useState(''),
			[winHeight, setWinHeight] = useState(''),
			[mobileWidth, setMobileWidth] = useState(''),
			[wideScreen, setWideScreen] = useState(false);

		useLayoutEffect(() => {
			const winWidth = parseInt(window.innerWidth || 0),
				winHeight = parseInt(window.innerHeight || 0),
				mobileWidthL = winWidth <= 768;

			setMobileWidth(mobileWidthL);
			setWideScreen((winWidth / winHeight) >= 1.7);
			setWinWidth(winWidth);
			setWinHeight(winHeight);

			setSizeSet(true);
		}, []);

		return sizeSet ? <Comp {...{ ...props, winWidth, winHeight, mobileWidth, wideScreen }} /> : null;
	};
};


export default Sizer;
